import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-col">
            <h4>고객센터</h4>
            <ul>
              <li><Link to="/help">도움말</Link></li>
              <li><Link to="/faq">자주 묻는 질문</Link></li>
              <li><Link to="/shipping">배송 안내</Link></li>
              <li><Link to="/return-policy">반품/교환 안내</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>쇼핑 가이드</h4>
            <ul>
              <li><Link to="/how-to-order">주문 방법</Link></li>
              <li><Link to="/payment">결제 안내</Link></li>
              <li><Link to="/delivery">배송 방법</Link></li>
              <li><Link to="/buyer-protection">구매자 보호</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>월드쉽 소개</h4>
            <ul>
              <li><Link to="/about">회사 소개</Link></li>
              <li><Link to="/terms">이용약관</Link></li>
              <li><Link to="/privacy">개인정보처리방침</Link></li>
              <li><Link to="/contact">문의하기</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>결제수단</h4>
            <div className="payment-icons">
              <span>VISA</span>
              <span>Master</span>
              <span>Toss</span>
              <span>Kakao Pay</span>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-business">
          <div className="footer-logo-text">WorldShip</div>
          <div className="footer-business-info">
            <p>상호명: 월드쉽 (WORLDSHIP) | 대표: 장형원</p>
            <p>사업자등록번호: 477-17-02623</p>
            <p>주소: 경상남도 창원시 진해구 월남로 142, 남양동</p>
            <p>통신판매업신고: 제 2025-창원진해-0203 호</p>
            <p>이메일: mahicanj@naver.com | 전화: 010-3351-3247</p>
          </div>
          <p className="footer-copyright">Copyright 2026 WORLDSHIP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
